module.exports = __webpack_public_path__ + "static/media/logoPlaceholder.89aa335f.svg";